import { Component } from '@angular/core';
import {  OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription,Observable } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { User } from '../shared/user';
import { UserService } from '../shared/user.service';

import { ConfirmationService } from 'primeng/primeng';

import { enDefualt, arDefualt } from '../../../shared/config';
import * as moment from 'moment';

@Component({
    selector: 'users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit, OnDestroy {

    @Input() selectedUser;
    @Output() selectedUserChange = new EventEmitter();
    @Input() operation: string;
    fromRoute: boolean;

    users: User[];
    roles: any;
  


    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;

    constructor(public rootService: RootService,
        public userService: UserService,
        public route: ActivatedRoute,
        public router: Router,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) {
            translate.onLangChange.subscribe((event) => {
                this.translateList();
            });

    }

    dateSort(event, DateField) {

        let comparer = function (a, b): number {
            let result: number = -1;

            if (a[DateField].ms > b[DateField].ms) result = 1;
            return result * event.order;
        };

        this.users.sort(comparer);
    }

    translateList(){
        
    }

    getUsers() {
        this.users = null;
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.userService.getAll()
            .subscribe(
            items => {
                if (items.users.length == 0) {
                    this.users = [];
                    this.noResult = true;
                } else {
                    this.users = items.users;
                    this.translateList();
                }
                this.roles= items.roles;
  


            },
            err => {
                this.requestError = true;
                this.rootService.toast.showErrorCode(err.code);
            });
    }
    getUser(user, operation) {

        if (operation == 'edit') {
            this.router.navigateByUrl('admin/user/' + user._id + '/update');
        } else if (operation == 'clone') {
            this.router.navigateByUrl('admin/user/' + user._id + '/clone');
        } else {
            this.router.navigate(['admin/user', user._id]);
        }



    }
    emitUser(user) {
        this.selectedUser = user;
        this.selectedUserChange.emit(this.selectedUser);
    }
    deleteUser(id: number) {
        this.confirmationService.confirm({
            message: this.translate.instant('form.common.deleteQ', { 'item': this.translate.instant('ctrl.user.view.header.one') }),
            header: this.translate.instant('form.common.delete'),
            icon: 'fa fa-trash',
            accept: () => {
                this.userService.delete(id)
                    .subscribe(
                    items => {
                        this.users = this.users.filter(user => user._id !== id);
                        this.rootService.toast.showSuccess(this.translate.instant('form.common.deleteItem', { 'item': this.translate.instant('ctrl.user.view.header.one') }));
                    }, //Bind to view
                    err => {
                        this.rootService.toast.showErrorCode(err.code);
                    });
            }
        });

    }
    ngOnInit() {


        this.getUsers();

    }

    ngOnDestroy() {
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        if (this.routeEvent) {
            this.routeEvent.unsubscribe();
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/module/user/users/users.component.ts